// Endpoint paths of the belegleser extraction service, relative to the configured
// apiBaseUrl (AiTableExtractorModuleConfig) — NOT the Softline connection.
// Use the {{param}} placeholder syntax; the data-access layer interpolates these.

export const AI_TABLE_EXTRACTOR_API_JOBS = '/jobs';
export const AI_TABLE_EXTRACTOR_API_JOB = '/jobs/{{jobId}}';
export const AI_TABLE_EXTRACTOR_API_JOB_PAGES = '/jobs/{{jobId}}/pages';
export const AI_TABLE_EXTRACTOR_API_JOB_PAGE = '/jobs/{{jobId}}/page/{{page}}';
export const AI_TABLE_EXTRACTOR_API_JOB_WORDS = '/jobs/{{jobId}}/words';
export const AI_TABLE_EXTRACTOR_API_JOB_FILE = '/jobs/{{jobId}}/file';
export const AI_TABLE_EXTRACTOR_API_JOB_DETECT_APPLY = '/jobs/{{jobId}}/detect/apply';
export const AI_TABLE_EXTRACTOR_API_JOB_APPLY_TEMPLATE = '/jobs/{{jobId}}/apply-template';
export const AI_TABLE_EXTRACTOR_API_JOB_TEMPLATE_STATUS = '/jobs/{{jobId}}/template-status';
export const AI_TABLE_EXTRACTOR_API_PLAUSIBILITY = '/plausibility';
export const AI_TABLE_EXTRACTOR_API_HEALTH = '/health';
